<template>
  <div class="resource-filters">
    <div class="format" :class="{ 'left-border': currentTab === 'all' }">
      <span
        v-for="(item, index) in formats"
        :key="item.type + 'formats'"
        :class="{ active: filterProps.theFormat === item.type }"
        @click="chooseOneFilter(item.type, 'theFormat')"
        >{{ item.name }}</span
      >
    </div>
    <template v-if="currentTab === 'all'">
      <div class="dropdown-label">
        <span>{{ filterProps.theCategory.name }}</span>
        <i class="iconfont iconxiala-copy"></i>
        <dropdown
          @chooseDrop="chooseCate"
          keyName="id"
          :theType="filterProps.theCategory"
          :types="filterProps.allCategories"
        ></dropdown>
      </div>
      <div class="dropdown-label">
        <span style="max-width: 80px;overflow: hidden;text-overflow: ellipsis;">{{ filterProps.theMember.name }}</span>
        <i class="iconfont iconxiala-copy"></i>
        <dropdown
          @chooseDrop="chooseMember"
          keyName="level"
          :theType="filterProps.theMember"
          :types="filterProps.allMemberLevels"
        ></dropdown>
      </div>
    </template>
  </div>
</template>

<script>
import dropdown from "./dropdown.vue";
export default {
  name: "resourceFilters",
  props: {
    currentTab: {
      type: String,
      default: "all",
    },
    filterProps: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      formats: [
        {
          name: "横版",
          type: "Horizontal",
        },
        {
          name: "竖版",
          type: "Vertical",
        },
      ],
    };
  },
  components: {
    dropdown,
  },
  methods: {
    chooseOneFilter(data, prop) {
      this.$emit("chooseOneFilter", { data, prop });
    },
    chooseMember(data) {
      this.chooseOneFilter(data, "theMember");
    },
    chooseCate(data) {
      this.chooseOneFilter(data, "theCategory");
    },
  },
};
</script>

<style lang="scss" scoped>
.resource-filters {
  display: flex;
  padding: 12px 0;
  height: 48px;
  align-items: center;
  .format {
    color: #474261;
    font-size: 12px;
    line-height: 16px;
    padding: 2px 0;
    word-break: keep-all;
    margin-right: 4px;
    &.left-border {
      border-right: 1px solid #e6e6e6;
    }
    span {
      cursor: pointer;
      margin-right: 14px;
      &.active {
        color: #5778fb;
      }
    }
  }
  /deep/ .dropdown-label {
    padding: 4px 2px 4px 10px;
    border-radius: 4px;
    &:hover {
      background-color: #f4f4f4;
    }
    .dropdown {
      top: 24px;
      padding-top: 6px;
      &-ul {
        width: 160px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/resourceFilters.vue